<template>
  <div class="consultancy-service-section">
    <div class="background-container">
      <!-- Contenedor para el fondo -->
    </div>
    
    <div class="content-container">
      <div class="content">
        <div class="consultancy-layout">
          <!-- Sección superior izquierda en columna -->
          <div class="left-column">
            <div class="upper-section">
              <div class="title-section">
                <h1 class="section-title">{{ translate('landing.consultancy_title', 'CONSULTANCY') }}</h1>
                <h2 class="subtitle">{{ translate('landing.consultancy_subtitle', 'THAT MAKES YOU GROWTH') }}</h2>
              </div>
              <div class="action-section">
              <a @click="openTawkChat" class="cta-button button">{{ translate('landing.hire_us', 'HIRE US!') }}</a>         
              </div>
            </div>
          </div>
          
          <!-- Imagen en el centro con tamaño reducido -->
          <div class="center-column">
            <div class="image-container">
              <div class="image-background"></div>
              <div class="image-section">
                <img src="@/assets/technopawsImages/consultancy-team.png" alt="Consultancy Team" class="service-image">
              </div>
            </div>
          </div>
          
          <!-- Contenedor inferior -->
          <div class="bottom-row">
            <!-- Espacio vacío a la izquierda -->
            <div class="bottom-spacer"></div>
            
            <!-- Parte de beneficios a la derecha -->
            <div class="lower-section">
              <div class="lower-content">
                <div class="lightbox">
                  <h2 class="lower-title">{{ translate('landing.consultancy_tagline', 'Our best experts to improve your business, optimize workflows and reduce costs.') }}</h2>
                  <div class="benefits-list">
                  <p class="main-description">{{ translate('landing.consultancy_description', 'Technopaws offers specialized consultancy services to help pet businesses align their customer care, operations, and technology for sustainable growth. Whether you\'re looking to improve client retention, streamline daily workflows, or adopt digital tools that make life easier, our team understands the unique challenges of the pet industry. We help you uncover inefficiencies, modernize your approach, and implement solutions that enhance both business performance and customer satisfaction:because happy clients mean healthy pets and loyal customers.') }}</p>
                </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'ConsultancyServiceSection',
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  },
  methods: {
    openTawkChat() {
      // Abrir el chat de tawk.to
      if (window.Tawk_API && window.Tawk_API.maximize) {
        window.Tawk_API.maximize();
      } else {
        console.warn('Tawk.to API no está disponible');
      }
    }
  }
}
</script>

<style scoped>
/* Usamos las variables globales de fuentes definidas en App.vue */
:root, body, * {
  font-family: var(--font-primary) !important;
}

:root {
  /* Variables globales si son necesarias */
}

.consultancy-service-section {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #09405c;
  overflow: hidden;
}

/* Contenedor para el fondo */
.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/technopawsImages/consultancy.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #09405c;
  z-index: 1;
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
  overflow-y: auto; /* Permitir scroll vertical si es necesario */
}

/* Nuevo layout para la sección de consultoría */
.consultancy-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  grid-template-areas: 
    "left center"
    "bottom bottom";
  gap: 1.5rem;
  width: 100%;
  padding: 0rem;
}

.left-column {
  grid-area: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
}

.center-column {
  grid-area: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-row {
  grid-area: bottom;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

/* Estilo para barras de desplazamiento (Chrome, Edge, Safari) */
.content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.content::-webkit-scrollbar-track {
  background: transparent;
}

.content::-webkit-scrollbar-thumb {
  background-color: rgba(9, 64, 92, 0.5);
  border-radius: 20px;
  border: 2px solid transparent;
}

.content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(9, 64, 92, 0.8);
}

.header-section {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 10;
  font-family: 'Montserrat', 'Arial', sans-serif;
}

.title-section {
  text-align: left;
  margin-bottom: 2rem;
  width: 100%;
  font-family: 'Montserrat', 'Arial', sans-serif;
}

.section-title {
  color: #09405c; /* Sobrescribimos el color para este componente */
  margin: 0;
  text-align: left;
}

.subtitle {
  margin-top: 0.5rem;
  color: #4a9d76;
  text-transform: uppercase;
}

.action-section {
  text-align: left;
  margin: 3.5rem 0;
  width: 100%;
}

.cta-button {
  background-color: #09405c;
  color: white;
  /* El resto de propiedades ahora vienen de la clase global cta-button */
}

.upper-section {
  width: 100%;
  height: 50%;
  padding-left: 1rem;
  padding-top: 7rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Alineado a la izquierda */
  text-align: left; /* Texto alineado a la izquierda */
  position: relative;
}

.lower-section {
  width: 100%;
  color: white;
  text-align: justify;
  z-index: 10;
  position: relative;
}

.lower-title {
  color: #ffffff;
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.lightbox {
  background-color: rgba(9, 93, 110, 0.8);
  backdrop-filter: blur(8px);
  border-radius: 10px;
  padding: 2rem;
}

.main-description {
  color: white;
  line-height: 1.6;
  text-align: justify;
}

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: left;
  font-family: 'Montserrat', 'Arial', sans-serif;
}

.lower-paragraph {
  font-size: 1.5rem;
  margin-bottom: 2rem; 
  font-family: 'Montserrat', 'Arial', sans-serif;
  line-height: 1.6;
}

.benefit-item {
  font-weight: bold;
  font-size: 1.5rem;
  font-family: 'Montserrat', 'Arial', sans-serif;
}

.navigation-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.nav-button {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  gap: 0.5rem;
  padding: 0.7rem 1.2rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  text-decoration: none;
}

.nav-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.next-button i {
  font-size: 1.3rem;
  margin-left: 0.3rem;
}

.image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  width: 100%;
}

.image-section {
  position: relative;
  width: 80%; /* Tamaño reducido */
  z-index: 5;
  padding-top: 5rem;
}

.service-image {
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Media queries */
@media (max-width: 480px) {
  .background-container {
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
  }

  .consultancy-service-section {
    padding: 3rem 0;
  }
  
  .consultancy-layout {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas: 
      "left"
      "center"
      "bottom";
    padding: 0rem;
    max-width: 100%;
  }

  .bottom-row {
    justify-content: center;
    margin: 0 auto;
    width: 100%;
    max-width: 95%;
  }
  
  .lower-section {
    width: 100%;
    margin: 0 auto;
  }
  
  .upper-section {
    padding: 0rem;
    padding-left: 0rem;
  }
  
  .title-section {
   text-align: center;
   margin-bottom: 0rem;
   width: 100%;
   font-family: 'Montserrat', 'Arial', sans-serif;
  }
  
  .section-title {
    margin: 1rem 0;
    text-align: center;
  }
  
  .subtitle {
    margin: 0rem 1rem;
    text-align: center;
  }

  .lower-title {
    text-align: center;
    margin: 0rem 0 0rem 1;
  }
  
  .benefit-item {
    font-size: 1.25rem;
    font-family: 'Montserrat', 'Arial', sans-serif;
  }

  .main-description {
    margin: 0rem;
    color: white;
    line-height: 1.6;
    text-align: left;
  }
  
  .image-section {
    width: 100%;
    padding: 0.3rem;
  }
  
  .service-image {
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .action-section {
    text-align: center;
    margin: 2rem 0 0rem 0;
    width: 100%;
  }
  
  .lightbox {
    padding: 1rem 1rem;
    margin-top: 1rem;
    width: 100%;
    max-width: 100%;
  }

}
</style>
